import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';
import CalculatorHome from './views/CalculatorHome.vue';
import LifeResult from './views/LifeResult.vue';
import LifeExpress from './views/LifeExpress.vue';
import LifeDetailed from './views/LifeDetailed.vue';
import IncomeResult from './views/IncomeResult.vue';
import IncomeExpress from './views/IncomeExpress.vue';
import IncomeDetailed from './views/IncomeDetailed.vue';

Vue.use(Router);

const metaLife = {
    title: 'Life Insurance Calculator Australia | Insuranceline',
    meta: [
        {
            description:
                'Wondering how much life insurance you may need? You can calculate your expenses and find some options using our life insurance calculator.'
        }
    ]
};

const metaIncome = {
    title: 'Income Protection Insurance Calculator | Insuranceline',
    meta: [
        {
            description:
                'Work out how much income protection insurance you may need with this easy-to-use calculator. Calculate your expenses.'
        }
    ]
};

export default new Router({
    base: '/calculator',
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'home',
            component: Home
        },
        {
            path: '/life',
            name: 'LifeCalculatorHome',
            props: {
                title: 'Life Insurance Calculator',
                descriptionExpress: 'Simply enter in your outstanding debt for a quick cover amount estimate.',
                descriptionDetailed: 'Enter in more things that are important such as income, expenses etc',
                meta: metaLife
            },
            component: CalculatorHome
        },
        {
            path: '/life/express/results',
            name: 'ExpressLifeResults',
            component: LifeResult
        },
        {
            path: '/life/detailed/results',
            name: 'DetailedLifeResults',
            component: LifeResult
        },
        {
            path: '/life/express/',
            name: 'LifeExpress',
            component: LifeExpress
        },
        {
            path: '/life/detailed/',
            name: 'LifeDetailed',
            component: LifeDetailed,
            props: {
                meta: metaLife
            }
        },
        {
            path: '/income',
            name: 'IncomeCalculatorHome',
            props: {
                title: 'Income Protection Insurance Calculator',
                descriptionExpress: 'Simply enter in your outstanding debt for a quick cover amount estimate',
                descriptionDetailed: 'Enter in more things that are important such as income, expenses etc.',
                meta: metaIncome
            },
            component: CalculatorHome
        },
        {
            path: '/income/express/results',
            name: 'ExpressIncomeResults',
            component: IncomeResult
        },
        {
            path: '/income/detailed/results',
            name: 'DetailedIncomeResults',
            component: IncomeResult
        },
        {
            path: '/income/express/',
            name: 'IncomeExpress',
            component: IncomeExpress
        },
        {
            path: '/income/detailed/',
            name: 'IncomeDetailed',
            component: IncomeDetailed,
            props: {
                meta: metaIncome
            }
        }
    ]
});
